import { Requester } from '@/src/features/api/requester/requester';

export enum UserRole {
  Admin = 'admin',
  User = 'user',
}

export interface MeDto {
  id: string;
  firstName?: string;
  lastName?: string;
  age?: number;
  email: string;
  isActive: boolean;
  role: UserRole;
  version: number;
  createdDate: Date;
  updatedDate: Date;
  deletedDate: Date;
  iat: number;
  exp: number;
}

export const meRequest = async (): Promise<MeDto> => {
  const { request } = Requester.get<undefined, undefined, MeDto>({
    path: 'identity/auth/me',
  });

  const response = await request;
  return response.data;
};
